<template>
  <div class="footer-comp">
      <div class="main">
          <div class="about-contact">
              <div class="left">
                  <div class="about-us">
                      <div class="headline">{{ $t("footer.aboutKepler") }}</div>
                      <ul class="about-item">
                          <li @click="toKepler('about')">
                            <a class="nav-link newnavlink navbar-item" href="https://www.gotokepler.com/about" target="_blank">{{ $t("footer.ourStory") }}</a>
                          </li>
                          <li>
                            <a class="nav-link newnavlink navbar-item" href="https://www.gotokepler.com/contact" target="_blank">{{ $t("footer.contactUs") }}</a>
                          </li>
                      </ul>
                  </div>
                  <div class="contact-us">
                      <div class="headline">{{ $t("footer.followorContactUs") }}</div>
                      <ul class="about-item">
                          <!-- <li>
                              <span class="about-item-title">咨询热线</span>
                              <span class="about-item-value">400-837-5577</span>
                          </li> -->
                          <li>
                              <span class="about-item-title">{{ $t("footer.email") }}</span>
                              <span class="about-item-value">contact@gotokepler.com</span>
                          </li>
                      </ul>
                      <div class="bottom-icon-list">
                        <ul v-if="locale === 'zh'" class="icon-list zh-icon-list">
                            <li class="hover-show-wrap">
                                <img src="@/assets/image/icon/wechat.png" alt="">
                                <div class="preview-box">
                                    <img src="@/assets/image/qrcode/wechat.png" alt="">
                                </div>
                            </li>
                            <li>
                                <a :href="socialMediaUrl.weibo.href" target="_blank">
                                    <img src="@/assets/image/icon/weibo.png" alt="">
                                </a>
                            </li>
                            <li>
                                <a :href="socialMediaUrl.bili.href" target="_blank">
                                    <img src="@/assets/image/icon/bili.png" alt="">
                                </a>
                            </li>
                        </ul>

                        <ul v-if="locale === 'en'" class="icon-list en-icon-list">
                            <li>
                                <a :href="socialMediaUrl.youtube.href" target="_blank">
                                    <img src="@/assets/image/icon/YouTube.png" alt="">
                                </a>
                            </li>
                            <li>
                                <a :href="socialMediaUrl.Instagram.href" target="_blank">
                                    <img src="@/assets/image/icon/camera.png" alt="">
                                </a>
                            </li>
                            <li>
                                <a :href="socialMediaUrl.x.href" target="_blank">
                                    <img src="@/assets/image/icon/x.png" alt="">
                                </a>
                            </li>
                            <li>
                                <a :href="socialMediaUrl.facebook.href" target="_blank">
                                    <img src="../../assets/image/icon/facebook.png" alt="">
                                </a>
                            </li>
                            <li>
                                <a :href="socialMediaUrl.linkedIn.href" target="_blank">
                                    <img src="@/assets/image/icon/linkedIn.png" alt="">
                                </a>
                            </li>
                        </ul>
                      </div>
                  </div>
              </div>


          </div>
          <div class="copyright">
              {{ $t("footer.copyright1") }}<span v-if="locale === 'zh'"> | </span><a href="https://beian.miit.gov.cn/" target="_blank" v-if="locale === 'zh'">{{ $t("footer.copyright2") }}</a>
          </div>
      </div>
  </div>
</template>

<script setup>
import { socialMediaUrl } from '@/config'
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();

</script>

<style lang="scss" scoped>
.footer-comp {
  width: 100%;
  background: rgba(255,255,255,0.03);
  .main {
      width: 1104px;
      margin: 0 auto;
      ul, li {
          padding: 0;
          margin: 0;
          list-style: none;
      }
      .about-contact {
          padding: 80px 0 73px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          .left {
              display: flex;
              flex-wrap: wrap;
              .about-us {
                  margin-right: 144px;
                  
              }
          }
          .headline {
              font-size: 16px;
              line-height: 24px;
              font-weight: 500;
              color: #ffffff;
              margin-bottom: 21px;
          }
          ul.about-item {
              li {
                  height: 24px;
                  font-size: 12px;
                  display: flex;
                  align-items: center;
                  cursor: pointer;
                  color: rgba(255,255,255,0.6);
                  &:first-child {
                      margin-bottom: 10px;
                  }
                  .about-item-title {
                      display: inline-block;
                      width: 72px;
                      cursor: default;
                      word-wrap: nowrap;
                  }
                  .about-item-value {
                      font-size: 16px;
                      cursor: default;
                      color: #ffffff;
                  }
                  a {
                      &:hover {
                          color: #386AEA;
                      }
                  }
              }
          }

          .contact-us{
                .bottom-icon-list {
                    margin: 24px auto 0;
                    .icon-list {
                        display: flex;
                        align-items: center;    
                        li {
                            width: 40px;
                            height: 40px;
                            cursor: pointer;
                            margin-right: 24px;
                            img {
                                width: 100%;
                            }
                            &:last-child {
                                margin-right: 0;
                            }
                        }
                    }
                    .zh-icon-list {
                        .hover-show-wrap {
                            position: relative;
                            .preview-box {
                                display: none;
                                width: 130px;
                                height: 130px;
                                position: absolute;
                                left: 50%;
                                top: -138px;
                                z-index: 99;
                                transform: translateX(-50%);
                                transition: display 0.3s linear;
                                img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: contain;
                                }
                            }
                            &:hover {
                                .preview-box {
                                    display: block;
                                }
                            }
                        }
                    }
                }
          }
      }
      .copyright {
          border-top: 1px solid rgba(255,255,255,0.2);
          padding: 16px 0 56px;
          color: rgba(255,255,255,0.6);
          font-size: 12px;
          a {
              color: rgba(255,255,255,0.6);
              text-decoration: none;
          }
      }
  }
}

@media (max-width:1200px) {
  .footer-comp {
      .main {
          width: 80%;
      }
  }
}

@media (max-width: 1000px) {
  .footer-comp {
      .main {
          width: 80%;
        
      }
  }
}
@media (max-width: 800px) {
  .footer-comp {
      .main {
          width: 80%;
          .left {
              .contact-us {
                  .headline {
                      margin-top: 20px;
                  }
              }
          }
      }
  }
}
</style>